import { Base } from "../../framework/base";
import { EventUserState, UserFurtherEducationState } from "../enums";

export interface IRecordListItemUserFamiliarization {
    id: string;
    familiarizationId: string;
    name: string;
    startDate: number;
    endDate: number;
    validityEndDate: number;
    archived: boolean;
    state: UserFurtherEducationState;
    userState: EventUserState;
    hasAttachments: boolean;
    modifyDate: number;
}

export class RecordListItemUserFamiliarization implements IRecordListItemUserFamiliarization {
    id: string;
    familiarizationId: string;
    name: string;
    startDate: number;
    endDate: number;
    validityEndDate: number;
    archived: boolean;
    state: UserFurtherEducationState;
    userState: EventUserState;
    hasAttachments: boolean;
    modifyDate: number;

    constructor();
    constructor(obj: IRecordListItemUserFamiliarization);
    constructor(obj?: any) {
        this.id = obj && obj.id || "";
        this.familiarizationId = obj && obj.familiarizationId || "";
        this.name = obj && obj.name || "";
        this.startDate = obj && obj.startDate || 0;
        this.endDate = obj && obj.endDate || null;
        this.validityEndDate = obj && obj.validityEndDate || null;
        this.archived = obj && obj.archived || false;
        this.state = obj && obj.state || UserFurtherEducationState.Valid;
        this.userState = obj && obj.userState || EventUserState.NotHandler;
        this.hasAttachments = obj && obj.hasAttachments || false;
        this.modifyDate = obj && obj.modifyDate || 0;
    }

    static sortRecordListItemUserFamiliarizations(items: IRecordListItemUserFamiliarization[], column: string, asc: boolean): IRecordListItemUserFamiliarization[] {
        if (!items && items.length < 2) return items;
        if (column === "validityDuration") {
            return items.sort((a: IRecordListItemUserFamiliarization, b: IRecordListItemUserFamiliarization) => {
                if (!a || !b) return 0;
                if (!a.validityEndDate && !b.validityEndDate) {
                    return ((asc ? 1 : -1) * -1 * Base.numCompare(a.startDate, b.startDate));
                }
                if (!a.validityEndDate) {
                    return asc ? 1 : -1;
                }
                if (!b.validityEndDate) {
                    return asc ? -1 : 1;
                }
                return (asc ? 1 : -1) * Base.numCompare(a.validityEndDate, b.validityEndDate);
            });
        } else if (column === "startDate") {
            return items.sort((a: IRecordListItemUserFamiliarization, b: IRecordListItemUserFamiliarization) => { return (!a || !b) ? 0 : ((asc ? 1 : -1) * Base.numCompare(a.startDate, b.startDate)); });
        } else if (column === "validityEndDate") {
            return items.sort((a: IRecordListItemUserFamiliarization, b: IRecordListItemUserFamiliarization) => { return (!a || !b) ? 0 : ((asc ? 1 : -1) * Base.numCompare(a.validityEndDate, b.validityEndDate)); });
        } else if (column === "state") {
            return items.sort((a: IRecordListItemUserFamiliarization, b: IRecordListItemUserFamiliarization) => {
                if (!a || !b) return 0;
                let result = (asc ? 1 : -1) * Base.numCompare(a.state, b.state);
                if (result !== 0) {
                    return result;
                }
                result = (asc ? 1 : -1) * Base.strCompare(a.name, b.name);
                if (result !== 0) {
                    return result;
                }
                return ((asc ? 1 : -1) * Base.numCompare(a.startDate, b.startDate));
            });
        } else {
            return items.sort((a: IRecordListItemUserFamiliarization, b: IRecordListItemUserFamiliarization) => { return (!a || !b) ? 0 : ((asc ? 1 : -1) * Base.strCompare(a.name, b.name)); });
        }
    }
}